import { useIntl } from "react-intl";

import type {
  FindUserReservationFlightReservation,
  FindUserReservationHotelReservation,
} from "@/types/codegen";
import { formatCurrency } from "@/utils/currency";

type Props = {
  reservation:
    | FindUserReservationHotelReservation
    | FindUserReservationFlightReservation;
};

export const ReservationPaymentDetails = ({ reservation }: Props) => {
  const intl = useIntl();

  return (
    <section>
      <h3 className="section-title mt-4">
        {intl.formatMessage({
          id: "reservations.paymentDetails",
          defaultMessage: "Payment details",
        })}
      </h3>
      <ul className="section-card w-full space-y-2 text-sm">
        {reservation.externalReservation.reference.confirmation ? (
          <li className="flex w-full items-center justify-between">
            <span className="text-text-title">
              {intl.formatMessage({
                id: "reservations.orderNumber",
                defaultMessage: "Order number",
              })}
            </span>
            <span className="font-semibold text-text-title">
              {reservation.externalReservation.reference.confirmation}
            </span>
          </li>
        ) : null}
        <li className="flex w-full items-center justify-between">
          <span className="text-text-title">
            {intl.formatMessage({
              id: "reservations.totalPrice",
              defaultMessage: "Total",
            })}
          </span>
          <span className="font-semibold text-text-title">
            {formatCurrency(reservation.price, reservation.currency)}
          </span>
        </li>
      </ul>
    </section>
  );
};
